module.exports = __webpack_public_path__ + "img/086-melilla.665e862f.svg";